// We need jQuery
var $ = window.jQuery;
export default function (){
    const $modal = $('#participant-details-modal');
    $('body').on('click', '.participant-modal-btn', function (event) {
        event.preventDefault();
        $('.ajax-loading').css('display', 'flex');
        $modal.find('.modal_participant_id').val($(this).data('participant_id'));
        $modal.find('.modal_enquiry_id').val($(this).data('enquiry_id'));
        $.ajax({
            url: tofinoJS.ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_participants_details',
                value: {
                    participant_id: $(this).data('participant_id'),
                    enquiry_id: $(this).data('enquiry_id')
                }
            },
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    $modal.find('.modal-body').html(response.html);
                    $modal.find('.modal-participant-name').html(response.data.fullName);
                    $modal.find('.modal-title, .modal-footer').removeClass('d-none');
                }else{
                    $modal.find('.modal-title, .modal-footer').addClass('d-none');
                    $modal.find('.modal-body').html('<div class="alert alert-danger">Failed loading participants details! Please try again.</div>');
                }
                $modal.modal('show');
                $('.ajax-loading').hide();
            }
        })
    });
}